import { JsonForms, JsonFormsInitStateProps } from "@jsonforms/react";
import {
  JsonFormsCore,
  JsonSchema,
  UISchemaElement,
  createAjv,
} from "@jsonforms/core";

import { renderers } from "./renderers";
import { cells } from "./cells";

const defaultAjv = createAjv();

type JsonFormsProps = {
  schema: JsonSchema;
  uischema?: UISchemaElement;
  data: any;
  onChange: (data: any, errors?: JsonFormsCore["errors"]) => void;
  readonly?: boolean;
  config?: Record<string, any>;
} & Omit<Partial<JsonFormsInitStateProps>, "schema" | "uischema" | "data">;

export function WeldJsonForms({
  schema,
  uischema,
  data,
  onChange,
  readonly,
  config,
  renderers: customRenderers,
  cells: customCells,
  ...rest
}: JsonFormsProps) {
  return (
    <JsonForms
      schema={schema as JsonSchema}
      uischema={uischema}
      data={data}
      renderers={customRenderers ?? renderers}
      cells={customCells ?? cells}
      onChange={({ data, errors }) => onChange(data, errors)}
      readonly={readonly}
      ajv={defaultAjv}
      config={{
        showUnfocusedDescription: true,
        ...config,
      }}
      {...rest}
    />
  );
}
